<div *ngIf="ready">
    <span *ngIf="refundTransaction">
        {{ refundTransaction.created_at | date: "longDate" }}
        (#{{ refundTransaction.id }})
    </span>

    <div *ngIf="!refundTransaction && isRefundable">
        <div class="cursor-pointer">
            <span *ngIf="!asVendor" (click)="requestRefund()"
                >Request Refund</span
            >
            <span *ngIf="asVendor" (click)="refund()">Refund</span>
        </div>
    </div>
</div>
